var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "panelGroup", staticClass: "cf-node-properties__panel-group" },
    [
      _c("legend", { staticClass: "cf-node-properties__legend" }, [
        _c("span", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: "ROUTER_ROUTES",
              expression: "'ROUTER_ROUTES'"
            }
          ]
        })
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-success btn-sm m-b-10",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.addRoute.apply(null, arguments)
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-plus" }),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "ROUTER_ADD_ROUTE",
                expression: "'ROUTER_ADD_ROUTE'"
              }
            ]
          })
        ]
      ),
      _vm._v(" "),
      _vm.orderedRoutes.length == 0
        ? _c("div", { staticClass: "text-center" }, [
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "ROUTER_NO_ROUTES",
                  expression: "'ROUTER_NO_ROUTES'"
                }
              ]
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Draggable",
        {
          attrs: {
            filter: ".cf-node-properties__panel--open",
            "prevent-on-filter": false
          },
          model: {
            value: _vm.orderedRoutes,
            callback: function($$v) {
              _vm.orderedRoutes = $$v
            },
            expression: "orderedRoutes"
          }
        },
        _vm._l(_vm.orderedRoutes, function(route, index) {
          return _c(
            "RoutePanel",
            {
              key: route.id,
              attrs: {
                index: index + 1,
                route: route,
                "open-options": true,
                "has-filter": true,
                sortable: true,
                "focus-element": _vm.focusElement(route)
              },
              on: {
                "update:route": function($event) {
                  route = $event
                }
              }
            },
            [
              _c("RouteFilter", {
                attrs: { "filter-criteria": route.criteria },
                on: {
                  "update:filterCriteria": [
                    function($event) {
                      return _vm.$set(route, "criteria", $event)
                    },
                    _vm.onRouteChange
                  ],
                  "update:filter-criteria": function($event) {
                    return _vm.$set(route, "criteria", $event)
                  }
                }
              })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }